/**
 * @desc 查询所有品种
 */
import { KindVo, PriceIndexKindQuery } from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryKindListParameter = PriceIndexKindQuery

const method = 'GET'
const url = '/content/mall/priceIndex/kind'

export const queryKindListApi = (
  params?: QueryKindListParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<KindVo>>({
    method,
    url,
    params,
    ...config
  })
}

queryKindListApi.method = method
queryKindListApi.url = url
